import MainApp from "./pages/MainApp";

export default function App() {
  return <MainApp />;
}